// Two-prong rail persistence — extracted from index.tsx (#339) so the view no
// longer touches localStorage for these keys.
//
// All four flags are sticky (localStorage) so a refresh restores the rail
// exactly as it was left (Brendan, Jul 8). `hidden` docks a prong away.
// `expanded` is the accordion state: false = resting (capped, scrolls inside),
// true = full content height. The old `collapsed` (header-only stat line) keys
// are retired — nothing reads them, and their orphaned data must stay ignored.
// Do not add a migration for them.
//
// Encoding contract (pre-dates this module — do not change): a flag is true
// only when storage holds the literal string 'true'. Anything else — absent,
// 'false', 'TRUE', '1' — reads as false. Writes store String(value), so a
// round-trip is exact.
export const TRACKER_HIDDEN_KEY = 'g1mt_tracker_prong_hidden';
export const FILLS_HIDDEN_KEY = 'g1mt_fills_prong_hidden';
export const TRACKER_EXPANDED_KEY = 'g1mt_tracker_prong_expanded';
export const FILLS_EXPANDED_KEY = 'g1mt_fills_prong_expanded';
// #1124 Data pressure prong. It starts HIDDEN, and an absent key reads false,
// so its visibility flag is "shown", not "hidden".
export const DATA_SHOWN_KEY = 'g1mt_data_prong_shown';
export const DATA_EXPANDED_KEY = 'g1mt_data_prong_expanded';

export type RailPrefKey =
  | typeof TRACKER_HIDDEN_KEY
  | typeof FILLS_HIDDEN_KEY
  | typeof TRACKER_EXPANDED_KEY
  | typeof FILLS_EXPANDED_KEY
  | typeof DATA_SHOWN_KEY
  | typeof DATA_EXPANDED_KEY;

export function readRailPref(key: RailPrefKey): boolean {
  try {
    return localStorage.getItem(key) === 'true';
  } catch {
    // Safari private mode — the rail starts at its defaults.
    return false;
  }
}

export function writeRailPref(key: RailPrefKey, value: boolean): void {
  try {
    localStorage.setItem(key, String(value));
  } catch {
    // Quota / private mode — dropping the write is acceptable for a
    // display-only preference; the toggle still works for this session.
  }
}
